import request from './api';
import { API_AUDIENCES } from '../constants/api';

export const getDailyShare = date =>
  request(`${API_AUDIENCES}sharedailyaverage`, {
    method: 'GET',
    params: { date }
  });

/**
 * Returns the first 15 most viewed television shows according to a given date
 * @param {date} date - date selected
 */
export const getRankingChannels = date =>
  request(`${API_AUDIENCES}ranking`, {
    method: 'GET',
    params: { date }
  });

export const getMonthlyShare = date =>
  request(`${API_AUDIENCES}share/month`, {
    method: 'GET',
    params: { date }
  });

export const getDailyReports = date =>
  request(`${API_AUDIENCES}files`, {
    method: 'GET',
    params: { date }
  });
